import { AuthenticatedTemplate } from "@azure/msal-react";
import { useMsal } from "@azure/msal-react";
import { Card, Container, Image } from "react-bootstrap";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

/***
 * Component to detail ID token claims with a description for each claim. For more details on ID token claims, please check the following links:
 * ID token Claims: https://docs.microsoft.com/en-us/azure/active-directory/develop/id-tokens#claims-in-an-id-token
 * Optional Claims:  https://docs.microsoft.com/en-us/azure/active-directory/develop/active-directory-optional-claims#v10-and-v20-optional-claims-set
 */
export const AdminDashboard = () => {
  const { instance, inProgress } = useMsal();
  const activeAccount: any = instance.getActiveAccount();

  // const activeAccount = instance.getActiveAccount();
  const data1 = useOutletContext();
  const [idToken, setIdToken] = useState();
  const userDetails = useSelector((state: RootState) => state.user.userDetails);
  const [hoveredItem, setHoveredItem] = useState(0);

  useEffect(() => {
    if (activeAccount && !activeAccount.idToken && inProgress === "none") {
      getTokenResponse();
    } else if (
      activeAccount &&
      activeAccount.idToken &&
      inProgress === "none"
    ) {
      setIdToken(activeAccount.idToken);
    }
  }, [activeAccount, inProgress]);

  const getTokenResponse = async () => {
    const tokenResponse: any = await instance.acquireTokenSilent({
      account: activeAccount,
      scopes: ["offline_access"],
    });
    setIdToken(tokenResponse.idToken);
  };

  const data = [
    {
      id: 1,
      imageUrl: "/images/coreA.webp",
      title: "COR Advantage",
      discription: "Assessing what children know and can do!",
      button: "Visit Site",
      code: "COR-A",
      link: process.env.REACT_APP_COR_A_URL + "/login",
    },
    {
      id: 2,
      imageUrl: "/images/cork.webp",
      title: "COR For Kindergarten",
      discription: "Assessing what children know and can do!",
      button: "Visit Site",
      code: "COR-K",
      link: process.env.REACT_APP_COR_K_URL,
    },
    {
      id: 3,
      imageUrl: "/images/classroomCoach.webp",
      title: "Classroom Coach",
      discription: "Improving preschool classroom quality!",
      button: "Visit Site",
      code: "COR-C",
      link: process.env.REACT_APP_COR_C_URL,
    },
    {
      id: 4,
      imageUrl: "/images/logoRSA.webp",
      title: "Ready School Assessment",
      discription: "Improving schools to ensure success for all children!",
      button: "Visit Site",
      code: "COR-R",
      link: process.env.REACT_APP_RSA_URL + "/login",
    },
    {
      id: 5,
      imageUrl: "/images/letterLink.webp",
      title: "Letter Links",
      discription: "Alphabet learning with children’s names!",
      button: "Visit Site",
      code: "COR-L",
      link: process.env.REACT_APP_LETTER_LINK_URL,
    },
    {
      id: 6,
      imageUrl: "/images/logoPQA.webp",
      title: "Program Quality Assessment",
      discription:
        "Reliable, scientifically validated assessment that reflects research-based, field-tested best practices in early childhood education.",
      button: "Visit Site",
      code: "COR-P",
      link: process.env.REACT_APP_COR_P_URL + "/login",
    },
    {
      id: 8,
      imageUrl: "/images/CurriculumNew.png",
      title: "Curriculum",
      discription:
        "Planning for active learning in infant, toddler, and preschool classrooms!",
      button: "Visit Site",
      code: "COR-CU",
      link: process.env.REACT_APP_CURR_URL + "/login",
    },
  ];
  return (
    <>
      <AuthenticatedTemplate>
        {/* {activeAccount ? (
          <Container className="h-full bg-white min-w-[82vw] p-4 overflow-auto  ">
            <div>Admin Dashboard Coming Soon</div>{" "}
          </Container>
        ) : null} */}
        {userDetails?.role === "HighscopeAdmin" ? (
          <div className="h-screen bg-white p-2 overflow-auto">
            <div className="mb-20 grid grid-cols-3 md:grid-cols-3 lg:grid-cols-3 2xl:grid-cols-3 gap-3 justify-items-center bg-white p-3 pb-10">
              {data.map((item) => (
                <div
                  key={item.id}
                  className="shadow-md w-full max-w-[500px] h-[300px] bg-gray-300 rounded-md overflow-hidden relative flex items-center justify-center cursor-pointer"
                  onMouseEnter={() => setHoveredItem(item.id)}
                  onMouseLeave={() => setHoveredItem(0)}
                  onClick={async () => {
                    try {
                      // Ensure we have the latest token before opening the link
                      let token: any = idToken;
                      if (!token) {
                        // Try to silently acquire a token
                        if (activeAccount) {
                          const tokenResponse: any = await instance.acquireTokenSilent({
                            account: activeAccount,
                            scopes: ["offline_access"],
                          });
                          token = tokenResponse?.idToken;
                          if (token) setIdToken(token);
                        }
                      }

                      if (!token) {
                        // As a fallback, don't open with `undefined` token. Log and abort.
                        console.error("No id token available to pass to the application link.");
                        return;
                      }

                      // Build the URL robustly (preserve existing query params)
                      const href = `${item.link}/?token=${encodeURIComponent(token)}`;
                      window.open(href, "_self");
                    } catch (err) {
                      console.error("Failed to acquire token or open link:", err);
                    }
                  }}
                >
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="max-w-[60%] max-h-[60%] object-contain rounded-md"
                  />
                  {hoveredItem === item.id && (
                    <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A80] via-[#1A1A1A40] to-transparent flex flex-col justify-end p-4">
                      <p className="text-white text-sm text-center">
                        {item.discription}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="flex items-center justify-center h-full">
            <h1 className="text-xl font-bold">No Applications</h1>
          </div>
        )}
      </AuthenticatedTemplate>
    </>
  );
};
